export const wxLite = 'https://help.niulinkcloud.cn/img/common/wx-lite.png'

export const wxNode = 'https://help.niulinkcloud.cn/img/common/wx-node.png'

export const wwwActivity = 'https://help.niulinkcloud.cn/img/common/www-activity.jpg'
